import { render, staticRenderFns } from "./course-add-other.vue?vue&type=template&id=2e6b03f7&scoped=true"
import script from "./course-add-other.vue?vue&type=script&lang=js"
export * from "./course-add-other.vue?vue&type=script&lang=js"
import style0 from "./course-add-other.vue?vue&type=style&index=0&id=2e6b03f7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e6b03f7",
  null
  
)

export default component.exports